define( function() {
	"use strict";

	return { guid: Date.now() };
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/ajax/var/nonce.js
// module id = 77
// module chunks = 0